import { Chat, Message } from '../types';

const CHATS_KEY = 'calmi_chats';
const CURRENT_CHAT_KEY = 'calmi_current_chat_id';

function generateId(): string {
  return `${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
}

function getChildId(): string {
  const childProfile = localStorage.getItem('calmi_child_profile');
  if (childProfile) {
    const parsed = JSON.parse(childProfile);
    return parsed.id || parsed.name || 'default';
  }
  return localStorage.getItem('calmi_child_id') || 'default';
}

function getChildName(): string {
  const childProfile = localStorage.getItem('calmi_child_profile');
  if (childProfile) {
    const parsed = JSON.parse(childProfile);
    return parsed.name || 'Usuario';
  }
  return 'Usuario';
}

export const chatService = {
  getChats(): Chat[] {
    try {
      const raw = localStorage.getItem(CHATS_KEY);
      if (!raw) return [];
      const chats: Chat[] = JSON.parse(raw);
      return chats.map(c => ({
        ...c,
        messages: (c.messages || []).map((m: any) => ({
          ...m,
          timestamp: new Date(m.timestamp)
        }))
      }));
    } catch {
      return [];
    }
  },

  getChat(id: string): Chat | null {
    return this.getChats().find(c => c.id === id) || null;
  },

  createChat(options?: { title?: string; initialMessage?: Message }): Chat {
    const chats = this.getChats();
    const now = new Date().toISOString();
    const messages: Message[] = options?.initialMessage ? [options.initialMessage] : [];
    const newChat: Chat = {
      id: generateId(),
      title: options?.title || `Chat ${chats.length + 1}`,
      childId: getChildId(),
      childName: getChildName(),
      createdAt: now,
      updatedAt: now,
      messages
    };
    localStorage.setItem(CHATS_KEY, JSON.stringify([...chats, newChat]));
    this.setCurrentChatId(newChat.id);
    return newChat;
  },

  updateChat(chat: Chat): void {
    const chats = this.getChats().map(c => (c.id === chat.id ? { ...chat, updatedAt: new Date().toISOString() } : c));
    localStorage.setItem(CHATS_KEY, JSON.stringify(chats));
  },

  deleteChat(id: string): void {
    const chats = this.getChats().filter(c => c.id !== id);
    localStorage.setItem(CHATS_KEY, JSON.stringify(chats));
    const current = this.getCurrentChatId();
    if (current === id) {
      this.setCurrentChatId(chats.length > 0 ? chats[0].id : '');
    }
  },

  getCurrentChatId(): string | null {
    return localStorage.getItem(CURRENT_CHAT_KEY);
  },

  setCurrentChatId(id: string): void {
    localStorage.setItem(CURRENT_CHAT_KEY, id);
  },

  addMessage(chatId: string, message: Message): void {
    const chat = this.getChat(chatId);
    if (!chat) return;
    chat.messages.push(message);
    this.updateChat(chat);
  }
};
